/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect,useState,useRef } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import AdminWorkCalendarModelPopup from "../../../components/modelpopup/AdminWorkCalendarModelPopup";
import { Link } from "react-router-dom";

const LeaveSettings = () => {
  const [includeWeekends, setIncludeWeekends] = useState(false);
  const [sendAttendanceNotifications, setSendAttendanceNotifications] = useState(false);
  const [lateArrivalNotifications, setLateArrivalNotifications] = useState(false);
  const [consecutiveLeaves, setConsecutiveLeaves] = useState("");
  const [notificationEmails, setNotificationEmails] = useState("");
  const [lateArrivalTime, setLateArrivalTime] = useState("");

  const [consecutiveLeaveType, setConsecutiveLeaveType] = useState(false);
  const [allowedLeaveTypes, setAllowedLeaveTypes] = useState([]);
  const [isFullScreen, setFullScreen] = useState(false);
  const maximizeBtnRef = useRef(null);

  const handleSave = () => {
    // Logic for saving settings
    alert("Settings saved successfully!");
  };


  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
        setFullScreen(true);
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          setFullScreen(false);
        }
      }
    };

    const cleanup = () => {
      if (isFullScreen && document.exitFullscreen) {
        document.exitFullscreen();
        setFullScreen(false);
      }
    };

    const maximizeBtn = maximizeBtnRef.current;
    maximizeBtn.addEventListener('click', handleClick);

    return () => {
      maximizeBtn.removeEventListener('click', handleClick);
      cleanup();
    };
  }, [isFullScreen]);


  const handleLeaveTypeChange = (e) => {
    const value = e.target.value;
    if (e.target.checked) {
      setAllowedLeaveTypes([...allowedLeaveTypes, value]);
    } else {
      setAllowedLeaveTypes(allowedLeaveTypes.filter((type) => type !== value));
    }
  };

  return (
    <>
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="content container-fluid">

          
        <div className="page-header page-top-icons">
          <div className="row align-items-center">
            <div className="col-md-4">
              <h3 className="page-title">Leave Settings</h3>
            </div>
            <div className="col-md-8 float-end ms-auto">
              <div className="d-flex title-head">
                <div className="view-icons">
                  <Link to="#" className="grid-view btn btn-link">
                    <i className="las la-redo-alt" />
                  </Link>
                  <Link to="#" className="list-view btn btn-link" id="collapse-header" ref={maximizeBtnRef}>
                    <i className="las la-expand-arrows-alt" />
                  </Link>
                </div>
                <Link to="#" className="btn add-btn custom-btn"  data-bs-toggle="modal" data-bs-target="#add_work_calendar">
                <i className="la la-plus-circle custom-icon" /> Work Calandar
                </Link>
              </div>
            </div>
          </div>
          </div>






          
   
          {/* /Page Header */}
          <div className="row">
            <div className="col-md-12">
              {/* Annual Leave */}
              <div className="card leave-box" id="leave_annual">
                <div className="card-body">
                  
                  {/* Include Weekends in Leave Calculation */}
                  <div className="leave-row">
                    <div className="leave-left">
                      <div className="input-box">
                        <label className="d-block">
                          Include Weekends in Leave Calculation
                        </label>
                        <div className="onoffswitch">
                          <input
                            type="checkbox"
                            name="onoffswitch"
                            className="onoffswitch-checkbox"
                            id="include_weekends_toggle"
                            checked={includeWeekends}
                            onChange={(e) =>
                              setIncludeWeekends(e.target.checked)
                            }
                          />
                          <label
                            className="onoffswitch-label"
                            htmlFor="include_weekends_toggle"
                          >
                            <span className="onoffswitch-inner" />
                            <span className="onoffswitch-switch" />
                          </label>
                        </div>
                        {includeWeekends && (
                          <div className="input-group mt-2">
                            <span className="input-group-text">
                              Number of consecutive leaves
                            </span>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter number"
                              value={consecutiveLeaves}
                              onChange={(e) =>
                                setConsecutiveLeaves(e.target.value)
                              }
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <hr />
                  {/* /Include Weekends */}
                  {/* Send Daily Attendance Notifications */}
                  <div className="leave-row">
                    <div className="leave-left">
                      <div className="input-box">
                        <label className="d-block">
                          Send Daily Attendance Notifications
                        </label>
                        <div className="onoffswitch">
                          <input
                            type="checkbox"
                            name="onoffswitch"
                            className="onoffswitch-checkbox"
                            id="attendance_notifications_toggle"
                            checked={sendAttendanceNotifications}
                            onChange={(e) =>
                              setSendAttendanceNotifications(e.target.checked)
                            }
                          />
                          <label
                            className="onoffswitch-label"
                            htmlFor="attendance_notifications_toggle"
                          >
                            <span className="onoffswitch-inner" />
                            <span className="onoffswitch-switch" />
                          </label>
                        </div>
                        {sendAttendanceNotifications && (
                          <div className="input-group mt-2">
                            <span className="input-group-text">Emails</span>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter recipient emails"
                              value={notificationEmails}
                              onChange={(e) =>
                                setNotificationEmails(e.target.value)
                              }
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <hr />
                  {/* /Send Daily Attendance Notifications */}
                  {/* Late Arrival Notifications */}
                  <div className="leave-row">
                    <div className="leave-left">
                      <div className="input-box">
                        <label className="d-block">
                          Late Arrival Notifications
                        </label>
                        <div className="onoffswitch">
                          <input
                            type="checkbox"
                            name="onoffswitch"
                            className="onoffswitch-checkbox"
                            id="late_arrival_toggle"
                            checked={lateArrivalNotifications}
                            onChange={(e) =>
                              setLateArrivalNotifications(e.target.checked)
                            }
                          />
                          <label
                            className="onoffswitch-label"
                            htmlFor="late_arrival_toggle"
                          >
                            <span className="onoffswitch-inner" />
                            <span className="onoffswitch-switch" />
                          </label>
                        </div>
                        {lateArrivalNotifications && (
                          <div className="input-group mt-2">
                            <span className="input-group-text">
                              Late After
                            </span>
                            <input
                              type="time"
                              className="form-control"
                              value={lateArrivalTime}
                              onChange={(e) =>
                                setLateArrivalTime(e.target.value)
                              }
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <hr />
                  {/* /Late Arrival Notifications */}
                  {/* Consecutive Leave Types */}
                  <div className="leave-row">
                    <div className="leave-left">
                      <div className="input-box">
                        <label className="d-block">
                          Allow Consecutive Different Leave Types
                        </label>
                        <div className="onoffswitch">
                          <input
                            type="checkbox"
                            name="onoffswitch"
                            className="onoffswitch-checkbox"
                            id="consecutive_leave_toggle"
                            checked={consecutiveLeaveType}
                            onChange={(e) =>
                              setConsecutiveLeaveType(e.target.checked)
                            }
                          />
                          <label
                            className="onoffswitch-label"
                            htmlFor="consecutive_leave_toggle"
                          >
                            <span className="onoffswitch-inner" />
                            <span className="onoffswitch-switch" />
                          </label>
                        </div>
                        {consecutiveLeaveType && (
                          <div className="input-group mt-2">
                            <span className="input-group-text">Allow Types</span>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="CL"
                                id="clCheckbox"
                                onChange={handleLeaveTypeChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="clCheckbox"
                              >
                                Casual Leave (CL)
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="PL"
                                id="plCheckbox"
                                onChange={handleLeaveTypeChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="plCheckbox"
                              >
                                Privilege Leave (PL)
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value="OL"
                                id="olCheckbox"
                                onChange={handleLeaveTypeChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="olCheckbox"
                              >
                                Optional Leave (OL)
                              </label>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <hr />
                  {/* /Consecutive Leave Types */}
                </div>
              </div>
              {/* /Annual Leave */}
            </div>
            {/* /Custom Create Leave */}
          </div>
          <div className="row">
            <div className="col-md-12 text-center">
              <button className="btn btn-primary" onClick={handleSave}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Content */}

      <AdminWorkCalendarModelPopup />
    </>
  );
};

export default LeaveSettings;
